/**
 * @module module/pagination-sk
 * @description <h2><code>pagination-sk</code></h2>
 *
 * Widget to let user page forward and backward. Page buttons will be
 * disabled/enabled depending on the offset/total/page_size values.
 *
 * Compatible with the server code httputils.PaginationParams.
 *
 * @attr offset {int} indicates the offset into the list of the items we are paged to.
 *
 * @attr page_size {int} the number of items we go forward/backward on a single page.
 *
 * @attr total {int} the total number of items that can be paged through or MANY if the
 * server doesn't know.
 *
 * @evt page-changed - Sent when user pages forward or backward. Check
 * e.detail.delta for how many pages changed and which direction.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PaginationSk", {
    enumerable: true,
    get: function() {
        return PaginationSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
// MANY (2^31-1, aka math.MaxInt32) is a special value meaning the
// server doesn't know how many items there are, only that it's more
// than are currently being displayed.
const MANY = 2147483647;
let PaginationSk = class PaginationSk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    render() {
        if (this.pageSize >= this.total && this.total !== MANY) {
            // Hide buttons if only one page is needed.
            return (0, _lit.html)``;
        }
        return (0, _lit.html)`
      <button
        ?disabled=${this._currPage() <= 1}
        title="Go to previous page of results."
        @click=${()=>this._page(-1)}
        class="prev">
        Prev
      </button>
      <div class="counter">page ${this._currPage()}</div>
      <button
        ?disabled=${!this._canGoNext(this.offset + this.pageSize)}
        title="Go to next page of results."
        @click=${()=>this._page(1)}
        class="next">
        Next
      </button>
      <button
        ?disabled=${!this._canGoNext(this.offset + 5 * this.pageSize)}
        title="Skip forward 5 pages of results."
        @click=${()=>this._page(5)}
        class="skip">
        +5
      </button>
    `;
    }
    _currPage() {
        return Math.round(this.offset / this.pageSize) + 1;
    }
    _canGoNext(next) {
        return this.total === MANY ? true : next < this.total;
    }
    _page(n) {
        this.dispatchEvent(new CustomEvent('page-changed', {
            detail: {
                delta: n
            },
            bubbles: true,
            composed: true
        }));
    }
    constructor(...args){
        super(...args);
        this.offset = 0;
        this.pageSize = 0;
        this.total = 0;
    }
};
_ts_decorate([
    (0, _decorators.property)({
        type: Number,
        reflect: true
    }),
    _ts_metadata("design:type", Number)
], PaginationSk.prototype, "offset", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Number,
        attribute: 'page_size',
        reflect: true
    }),
    _ts_metadata("design:type", Number)
], PaginationSk.prototype, "pageSize", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Number,
        reflect: true
    }),
    _ts_metadata("design:type", Number)
], PaginationSk.prototype, "total", void 0);
PaginationSk = _ts_decorate([
    (0, _decorators.customElement)('pagination-sk')
], PaginationSk);
